import { Link } from "react-router-dom";
import Instagram from "@material-ui/icons/Instagram";
import Dribble from "@material-ui/icons/SportsBasketball";
import Twitter from "@material-ui/icons/Twitter";
import YouTube from "@material-ui/icons/YouTube";
// import {sky} from 'Skye Studio Logo1 1 (1).png'
import sky from './sky.png'
import './responsive.css'

const Footer = () => {
  return (
    <div className="footer">
      <div>
        <div>
          <img src={sky}   alt="Blue Ski studio sign"  className="img" />
        </div>
        <ul>
          <li>
            <Link to="/">About</Link>
          </li>
          <li>
            <Link to="/">Features</Link>
          </li>
          <li>
            <Link to="/">Pricing</Link>
          </li>
          <li>
            <Link to="/">Carreers</Link>
          </li>
          <li>
            <Link to="/">Help</Link>
          </li>
          <li>
            <Link to="/">Privacy Policy</Link>
          </li>
        </ul>
      </div>
      <div>
        <p>Copyright Skistudio 2021 All Rights Reserved.</p>
        <div>
          <a href="https://instagram.com">
            <Instagram />
          </a>
          <a href="https://dribble.com">
            <Dribble />
          </a>
          <a href="https://twitter.com">
            <Twitter />
          </a>
          <a href="https://youtube.com">
            <YouTube />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
